import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const rejectClaim = (claimId, message) =>
  call(websocketFetch, 'reject_claim', {
    claim_id: claimId,
    message,
    version: 1,
  });
